export const MAX_ATTACHMENTS = 2;
export const MEBIBYTE = 1024 * 1024;
export const MAX_IMAGE_BYTES = 5 * MEBIBYTE;
export const MAX_DOCUMENT_BYTES = 30 * MEBIBYTE;
export const MAX_TOTAL_ATTACHMENT_BYTES = 30 * MEBIBYTE;
export const UPLOAD_ACCEPT = [
  'image/*',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/csv',
].join(',');

export const SIDEBAR_WIDTH_PIXELS = 380;
export const MIN_SIDEBAR_WIDTH_PIXELS = 320;
// Max width the companion's inner content currently utilises. Dragging
// beyond this wouldn't give the user more usable space; for a wider
// experience they can switch to fullscreen mode.
export const MAX_SIDEBAR_WIDTH_PIXELS = 1000;
export const SIDEBAR_WIDTH_STORAGE_KEY = 'aiCompanionSidebarWidth';

// Paths where the companion should auto-close (overlay/fullscreen pages)
const DISABLED_PATH_PATTERNS: RegExp[] = [
  /^\/goals\/graph/,
  /^\/goals\/\d+\/key_results\/new$/,
  /^\/goals\/\d+\/initiatives\/new$/,
  /^\/goals\/\d+\/initiatives\/\d+\/status_updates\/new$/,
  /^\/goals\/\d+\/relationships$/,
  /^\/goals\/\d+\/status_updates\/new$/,
  /^\/goals\/\d+\/stakeholders$/,
  /^\/conversations\/new$/,
  /^\/conversations\/edit\/\d+$/,
];

export const isDisabledPath = (pathname: string): boolean =>
  DISABLED_PATH_PATTERNS.some(pattern => pattern.test(pathname));
